/**
 * 5度电 3d版块
 */
export function fiveKwh3d() {
	(function () {
		$(function () {
			if ($('.five-kwh-3D-img-box').length === 0) {
				return;
			}

            let five3dBoxes = document.querySelectorAll('.five-kwh-3D-img-box');
            five3dBoxes.forEach(five3d => {
              let productModel = five3d.querySelector('product-model');
              if (productModel) {
                try {
                  productModel.loadContent();
                } catch (error) {
                  console.info('not init 3d model script');
                }
              }
            });

		})
	})();
}